import { render, staticRenderFns } from "./mktBrand.vue?vue&type=template&id=d443404a&"
import script from "./mktBrand.vue?vue&type=script&lang=js&"
export * from "./mktBrand.vue?vue&type=script&lang=js&"
import style0 from "./mktBrand.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports